<template>
<div class="footer-content" >
<div data-v-5431559e="" class="pc-footer" ><div data-v-5431559e="" class="footer_img"></div> <div data-v-5431559e="" class="text_group margin-top"><p data-v-5431559e="">
        NRC 公正做單平台擁有歐洲馬耳他博彩管理局（MGA）和博彩委員會（PAGCOR）頒發的合法執照。
      </p> <p data-v-5431559e="" class="border-bottom">
        註冊於英屬維爾京群島，是受國際博彩協會認可的合法博彩公司。進行註冊並娛樂前，請確保您年滿18周歲！
      </p> <p data-v-5431559e="">COPYRIGHT (©) 2020 NRC 公正做單平台版權所有，不得轉載。</p></div></div> 
      
      
</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
	methods: {

		customerService(){
			//var url = 'http://kefu.ziyun.com.cn/vclient/chat/?websiteid=137063';
			window.open(this.config.CustomerServiceUrl,'', 'height=768,width=1024,location=no,menubar=no,menubar=no');
		}

	},
    computed: {
		...mapGetters({
			config: 'config',
			user: 'user',
		}),
    },
};
</script>
<style scoped>
.footer-content .line-head{
    text-align: center;
    font-size: 2rem;
    line-height: 3.3rem;
}
.footer-content .footer-icon{
    font-size: 2rem;
    line-height: 3.3rem;
}
.footer-content .line-icon{
    text-align: center;
    font-size: 1.5rem;
}
.footer-content a{ color:#fff !important;}
.footer-content {
	height:64px;
	color:#FFF;
	font-size:15px;
}
.footer-content .footer-logo {
    width: 180px;
    height: 120px;
    float: left;
    margin-top: 10px;
    background: url(~assets/images/logo.png) no-repeat;
    background-size: cover;
	    background-position: -50px;
}
.footer-content .txt {
    margin-top: 50px;
    color: #999;
}

.footer-content .txt4 {
    width: 125px;
    height: 27px;
    display: inline-block;
    background: url(~assets/images/footer-pagcorlogo.png) no-repeat;
    background-size: cover;
    margin-right: 10px;
}
.footer-content .txt5 {
    width: 97px;
    height: 27px;
    display: inline-block;
    background: url(~assets/images/footer-bitmap.png) no-repeat;
    background-size: cover;
}
.footer-content .txt6 {
	margin-top:6px;
}
 .footer-content .txt .txt3 {
    margin-right: 3px;
    margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue